import { Component, OnInit, ViewChild } from '@angular/core';
import { FiltroListaSolicitacaoCompra } from '../filter/filtro-lista-solicitacao-compra';
import { PoBreadcrumb, PoDatepickerIsoFormat, PoDialogService, PoLookupColumn, PoModalAction, PoModalComponent, PoNotificationService, PoPageAction, PoPageFilter, PoSearchFilterMode, PoTableAction, PoTableColumn } from '@po-ui/ng-components';
import { ActivatedRoute, Router } from '@angular/router';
import { SolicitacaoCompraService } from '../service/solicitacao-compra.service';
import { AuthService } from 'src/app/service/auth.service';
import { UsuarioLookupService } from 'src/app/service/usuario-lookup-service';
import { FornecedorLookupService } from 'src/app/service/fornecedor-lookup-service';
import { SolicitacaoCompraAprovar, SolicitacaoCompraAprovarItem, defaultSolicitacaoCompraAprovar } from '../interface/solicitacao-compra';

@Component({
  selector: 'app-solicitacao-compra-aprovar',
  templateUrl: './solicitacao-compra-aprovar.component.html',
  styleUrl: './solicitacao-compra-aprovar.component.css'
})
export class SolicitacaoCompraAprovarComponent implements OnInit {

  tabelaPrincipalItens: Array<SolicitacaoCompraAprovarItem> = [];
  tabelaPrincipalFiltro: FiltroListaSolicitacaoCompra;
  tabelaPrincipalHeight: number =  window.innerHeight - 330;

  formatExtended: PoDatepickerIsoFormat = PoDatepickerIsoFormat.Extended;

  poSearchFilterMode: PoSearchFilterMode = PoSearchFilterMode.contains;

  usuarioColumnsFilters: Array<PoLookupColumn> = this.usuarioLookupService.getColumnsFilter();
  fornecedorColumnsFilters: Array<PoLookupColumn> = this.fornecedorLookupService.getColumnsFilter();

  breadcrumb: PoBreadcrumb = {
    items: [
      {label: 'Home', action: this.goHome.bind(this)},
      {label: 'Solicitação de Compra Aprovação'},
    ],
  };

  constructor(
    private router: Router,
    private activateRoute: ActivatedRoute,
    private poDialogService: PoDialogService,
    private poNotificationService: PoNotificationService,
    private solicitacaoCompraService: SolicitacaoCompraService,
    private authService: AuthService,
    public usuarioLookupService: UsuarioLookupService,
    public fornecedorLookupService: FornecedorLookupService,
  ) {
    this.tabelaPrincipalFiltro = new FiltroListaSolicitacaoCompra(authService,'filtro-lista-solicitacao-compra-aprovar');
    this.tabelaPrincipalFiltro.dados.order = 'C1_NUM desc'

  }

  @ViewChild('advancedFilterModal', {static: true}) advancedFilterModal!: PoModalComponent;


  async ngOnInit() {
    this.tabelaPrincipalFiltro.init().then(()=>{

      this.activateRoute.params.subscribe(async (params) => {
        if ('CC1NUM' in params) {
          this.tabelaPrincipalFiltro.dados.CC1NUM = params['CC1NUM'];
          this.tabelaPrincipalLoad();
        } else {
          this.advancedFilterActionModal();
        }
      })


    });
  }

  tabelaPrincipalLoad():void{

    this.tabelaPrincipalFiltro.postSalvarFiltro();

    this.solicitacaoCompraService.getSolicitacaoCompraAprovarLista(this.tabelaPrincipalFiltro.dados).subscribe({
      next: (lista) => {

        this.tabelaPrincipalItens = lista.items;

       }
    })

  }

  confirmarDecisao(decisao: string):void{

    const tabelaFiltrada: SolicitacaoCompraAprovar = defaultSolicitacaoCompraAprovar();

    tabelaFiltrada.items = this.tabelaPrincipalItens.filter(e => e.$selected)
    let descricaoDecisao = decisao==='L'?'Liberar':'Rejeitar'

    if (tabelaFiltrada.items.length > 0){

      this.poDialogService.confirm({
        title: `${descricaoDecisao} Solicitação de Compra`,
        message: `Deseja ${descricaoDecisao} os itens selecionados?`,
        confirm: () => {
          tabelaFiltrada.items.forEach(e => {
            e.CDECISAO = decisao;
          });

          this.solicitacaoCompraService.postSolicitacaoCompraAprovar(tabelaFiltrada).subscribe({
            next: () => {
              this.tabelaPrincipalLoad();
            }
          })

        }
      })

    } else {
      this.poNotificationService.warning({
        message: 'Escolha ao menos um item.'
      })
    }

  }

  public readonly tabelaPrincipalColunas: Array<PoTableColumn> = [
    {property: 'CC1NUM'    , label: 'Código'      , width: '10%', visible: true},
    {property: 'CC1ITEM'   , label: 'Item'        , width: '08%', visible: true},
    {property: 'CC1PRODUTO', label: 'Produto'     , width: '10%', visible: true},
    {property: 'CB1DESC'   , label: 'Descrição'   , width: '30%', visible: true},
    {property: 'CC1DESCRI' , label: 'Descrição SC', width: '30%', visible: true},
    {property: 'CC1UM'     , label: 'UM'          , width: '07%', visible: true},
    {property: 'NC1QUANT'  , label: 'Quantidade'  , width: '10%', visible: true , type: 'number', format: '1.4-4'},
    {property: 'CC1SOLICIT', label: 'Solicitante' , width: '10%', visible: true},
    {property: 'CC1CC'     , label: 'Centro Custo', width: '10%', visible: true},
    {property: 'CC1CONTA'  , label: 'Cta Ctb'     , width: '10%', visible: true},
    {property: 'CC1OBS'    , label: 'Observação'  , width: '30%', visible: true},
    {property: 'DC1EMISSAO', label: 'Emissão'     , width: '10%', visible: true, type: 'date'},
    {property: 'DC1DATPRF' , label: 'Necessidade' , width: '10%', visible: true , type: 'date'},
    {property: 'CC1FORNECE', label: 'Fornecedor'  , width: '10%', visible: false},
    {property: 'CA2NOME'   , label: 'Razão Social', width: '30%', visible: true},
  ]

  goHome(): void {
    this.router.navigateByUrl('');
  }

  //################################################################//
  // FILTRO
  //################################################################//
  public readonly filterSettings: PoPageFilter = {
    advancedAction: this.advancedFilterActionModal.bind(this),
  };

  advancedFilterActionModal(): void {
    this.advancedFilterModal.open();
  }

  public readonly advancedFilterPrimaryAction: PoModalAction = {
    action: () => {
      this.advancedFilterModal.close();
      this.tabelaPrincipalLoad();
    },
    label: 'Aplicar Filtros'
  };

}

